module.exports = __webpack_public_path__ + "images/psp/Truck/measure-your-truck.webp";